import {TeemillError} from './teemillError';

export class ApiError extends TeemillError {
  constructor(message?: string) {
    super(message || 'Api error');
  }
}
